import React from 'react';
import { SplashMessageContext } from './SplashMessageContext';

class SplashMessageProvider extends React.Component {
  state = {
    messages: [],
    isNewDash: false
  };

  render() {
    return (
      <SplashMessageContext.Provider value={this.state}>
        {this.props.children}
      </SplashMessageContext.Provider>
    );
  }

  // adds a splash message (fixed to bottom of page)
  addMessage = (message = {}, isNewDash = false) => {
    const messages = [...this.state.messages, message];

    // isNewDash flag will be used to determine which style error/message should be displayed.
    this.setState({ messages, isNewDash }, this.delayDeleteMessage);
    // this.setState({ messages, isNewDash });
  };

  deleteMessage = () => {
    // remove the first
    const messages = [
      ...this.state.messages.slice(1, this.state.messages.length)
    ];
    this.setState({ messages });
  };

  // clears the splash message after 5 second delay
  delayDeleteMessage = () => setTimeout(() => this.deleteMessage(), 5000);

  componentDidMount() {
    this.setState({ addMessage: this.addMessage });
  }
}
export default SplashMessageProvider;



// WEBPACK FOOTER //
// ./src/components/splashMessage/SplashMessageProvider.js